module.exports = __webpack_public_path__ + "img/dave_headshot_04_12_22.3abed299.jpg";